module.exports = __webpack_public_path__ + "img/HT_INJECTION.d0ea139f.png";